// extracted by mini-css-extract-plugin
module.exports = {"background404":"AtTechBackground_background404__fekPA"};